<template>
  <Modal
    class="scoped"
    full-height
    :modal-style="{ maxWidth: '900px' }"
    :title="filterSet.label"
  >
    <div class="card q-pa-lg column no-wrap full-height scroll">
      <ContentToggles
        class="justify-center"
        :disabled="!hasNormalAccess"
        :model-value="filterSet"
      />
      <CategoryAndLocationFilters
        :model-value="filterSet"
        :organisation-id="filterSet.organisation_id"
      />
      <SpecificSources :model-value="filterSet" />
    </div>
  </Modal>
</template>

<script>
import { storeToRefs } from "pinia";

import Modal from "shared/components/core/modals/Modal.vue";

import CategoryAndLocationFilters from "src/components/common/CategoryAndLocationFilters.vue";
import ContentToggles from "src/components/common/ContentToggles.vue";
import SpecificSources from "src/components/common/SpecificSources.vue";
import { useUserStore } from "src/stores/user";

export default {
  name: "ViewFilterSetModal",
  components: {
    Modal,
    CategoryAndLocationFilters,
    ContentToggles,
    SpecificSources,
  },
  props: {
    filterSet: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const userStore = useUserStore();
    const { hasNormalAccess } = storeToRefs(userStore);

    return { hasNormalAccess };
  },
};
</script>
